<template>
  <dialog-body ref="body" :ipaText="text" :text='subtext' class="readonly-body">
    <template v-slot:subtext>
      <span>
        <slot name="subtext">
          {{subtext}}
        </slot>
      </span>
    </template>
    <template v-slot:maintext>
      <span>
        <slot name="maintext">
          {{text}}
        </slot>
      </span>
    </template>
  </dialog-body>
</template>

<script>
import { defineComponent, computed, ref, onMounted, onBeforeUnmount, watch } from 'vue'
import { getCurrentInstance } from 'vue'
import DialogBody from '../DialogBody.vue'

export default defineComponent({
  components: {
    DialogBody
  },
  props: {
    text: {
      type: String,
      required: true
    },
    subtext: {
      type: String,
    },
    typingAnimation: {
      type: Boolean,
    },
    speed: {
      type: Number,
      validator: (speed)=>(speed>=1 && speed<=5)
    }
  },
  setup(props, context) {
    const root = getCurrentInstance();
    const resizeObserver = ref(null);

    const spacedText = computed(()=>{
      return props.text.replace(/ /g, '  ');
    })
    const typeDelay = computed(()=>{
      return 85 - (props.speed * 5)
    })

    const onResize = ()=>{
      if (props.typingAnimation){
        root.proxy.$refs.body.$refs.container.scrollTo(0, root.proxy.$refs.body.$refs.container.scrollHeight) 
      }
    }

    onMounted(()=>{
      resizeObserver.value = new ResizeObserver(onResize);
      resizeObserver.value.observe(root.proxy.$refs.body.$refs.innerContainer); 
    })

    onBeforeUnmount(()=>{
      resizeObserver.value.disconnect();
    })

    return {
      spacedText,
      typeDelay,
    }
  }
})
</script>

<style lang="scss" scoped>
.readonly-body ::v-deep .char{
  color: inherit
}
</style>
